module.exports = __webpack_public_path__ + "img/settings.35086ca3.svg";